export default __webpack_public_path__ + "static/media/logo__project__portfolio-site.775287c5.png";